module.exports = __webpack_public_path__ + "871aae45d943ae16e29a6f12ce7b3bc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/avatar.jpg
// module id = 180
// module chunks = 0